import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromUserDataLayer from './state/user-data-layer.reducer';
import { UserDataLayerEffects } from './state/user-data-layer.effects';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(fromUserDataLayer.FEATURE_KEY, fromUserDataLayer.reducer),
        EffectsModule.forFeature([UserDataLayerEffects]),
    ],
})
export class UserDataLayerDataAccessModule {}
